import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'
import * as models from '../models'

/**
 * Determines where org chart data is stored in local storage
 */
export function getLocalStorageKey(
  context: ents.core.admin.Context.ForApp,
  orgChartId: models.OrgChart.Id,
): string {
  return [
    context.tenantId,
    context.zoneId,
    context.appId,
    orgChartId,
    'orgChart',
  ].join('.')
}

export const saveToLocalStorage = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.actions.save.observe().pipe(
      rxjsUtils.latestFrom(({ data: { orgChartId } }) => ({
        context: meFeature.contexts.selectors.appContext.asObservable,
        data: feature.selectors.getOrgChartData({ orgChartId }).asObservable,
        orgChartId: rxjs.of(orgChartId),
      })),
      rxjs.map(({ context, orgChartId, data }) => {
        if (!context) {
          // TODO: turn `save` into a request action group and make this a
          // cancellation
          console.warn(
            `Cannot save ${orgChartId} org chart since the current context is unknown`,
          )
          return
        }
        const key = getLocalStorageKey(context, orgChartId)
        if (data) {
          window.localStorage.setItem(key, models.Data.toJson(data))
        } else {
          window.localStorage.removeItem(key)
        }
      }),
      rxjs.ignoreElements(),
    ),
)
